import { render, staticRenderFns } from "./inventory_status.vue?vue&type=template&id=2bae6b20"
import script from "./inventory_status.vue?vue&type=script&lang=js"
export * from "./inventory_status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports